import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationRecord } from 'src/app/notifications/interfaces/notifications-client';

export interface NotificationDetailDialogData {
  notification: NotificationRecord;
  iconClass: string;
  formattedDate: string;
}

export type NotificationDetailDialogResult =
  | { action: 'close' }
  | { action: 'navigate', notification: NotificationRecord }
  | { action: 'delete', notification: NotificationRecord };

@Component({
  selector: 'app-notification-detail-dialog',
  templateUrl: './notification-detail-dialog.component.html',
  styleUrls: ['./notification-detail-dialog.component.scss']
})
export class NotificationDetailDialogComponent {
  public deleting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: NotificationDetailDialogData,
    private dialogRef: MatDialogRef<NotificationDetailDialogComponent, NotificationDetailDialogResult>
  ) { }

  public close(): void {
    this.dialogRef.close({ action: 'close' });
  }

  public canNavigate(): boolean {
    var navigation = this.data && this.data.notification ? this.data.notification.navigation : null;
    return !!(navigation && navigation.type === 'CARGO_DETAIL' && navigation.entityId);
  }

  public navigate(): void {
    if (!this.canNavigate()) return;
    this.dialogRef.close({ action: 'navigate', notification: this.data.notification });
  }

  public delete(): void {
    if (this.deleting) return;
    this.deleting = true;
    this.dialogRef.close({ action: 'delete', notification: this.data.notification });
  }
}
